import { ArrowChevronLeftIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

const BackLink = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleRouterBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    navigate(-1)
  }

  return (
    <a
      href="#"
      onClick={handleRouterBack}
      className="c-flex c-gap-1 c-items-center c-no-underline hover:c-underline c-group"
    >
      <ArrowChevronLeftIcon className="c-h-3 c-w-3 c-text-primary group-hover:c-text-primary-300" />
      <span className="c-text-primary c-font-bold c-text-sm c-translate-y-px group-hover:c-text-primary-300">
        {t('components.navigation.return')}
      </span>
    </a>
  )
}

export default BackLink
